import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import customerGroupService from "..";
import { DeleteCustomerGroupPayload } from "../type";

function useRemoveCustomerGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (command: DeleteCustomerGroupPayload) => {
      return customerGroupService.removeCustomerGroups(command);
    },
    onSuccess: () => {
      notifications.show({
        title: "عملیات موفق",
        message: "عملیات با موفقیت صورت پذیرفت",
        color: "green",
      });

      queryClient.invalidateQueries({ queryKey: ["customerGroup"] });
    },
  });
}

export default useRemoveCustomerGroup;
